interface ColorMapping {
  [key: string]: string;
}

const COLOR_MAPPING: ColorMapping = {
  "#E6F2FF": "var(--background-blue)",
  "#D7DAE1": "var(--map-background-building-elements)",
  "#9CA3B6": "var(--content-tertiary-enabled)",
  white: "var(--background-primary-a-enabled)",
  "#ABB0C1": "var(--content-tertiary-hover)",
  "#F3F5F7": "var(--map-background-elements)",
  "#C8CCD6": "var(--map-background-elements-dark)",
  "#DFF6E8": "var(--map-border-exit-icon)",
  "#F2FCF6": "var(--map-border-exit-icon-external)"
};

export function replaceColorsWithVariables(text: string): string {
  let result = text;

  Object.entries(COLOR_MAPPING).forEach(([color, variable]) => {
    if (color.startsWith("#")) {
      const colorRegex = new RegExp(`(${color})`, "gi");
      result = result.replace(colorRegex, variable);
    }
  });

  const whiteRegex = /(\bwhite\b)/gi;
  result = result.replace(whiteRegex, (match) => {
    const beforeMatch = result.substring(0, result.indexOf(match));
    const afterMatch = result.substring(result.indexOf(match) + match.length);

    if (
      beforeMatch.match(/:\s*$/) ||
      beforeMatch.match(/['"]\s*$/) ||
      afterMatch.match(/^\s*[;}]/) ||
      afterMatch.match(/^\s*['"]/)
    ) {
      return COLOR_MAPPING["white"];
    }

    return match;
  });

  return result;
}

export function replaceColorsInFile(fileContent: string): string {
  return replaceColorsWithVariables(fileContent);
}

export function hasColorsToReplace(text: string): boolean {
  const colors = Object.keys(COLOR_MAPPING);
  return colors.some((color) => {
    if (color.startsWith("#")) {
      return text.toLowerCase().includes(color.toLowerCase());
    }
    if (color === "white") {
      const whiteRegex = /\bwhite\b/gi;
      return whiteRegex.test(text);
    }
    return false;
  });
}

export function getColorMapping(): ColorMapping {
  return { ...COLOR_MAPPING };
}
